import { testimonials } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';

export default function TestimonialSection() {
  return (
    <section className="w-full bg-accent-950 py-12 md:py-16">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs tracking-wide text-accent-200 bg-accent-900/60 border border-accent-700/60 px-2.5 py-1 rounded-full">
            <i className="ri-chat-quote-line"></i>
            读者怎么说
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
            他们把这里当作热点第一站
          </h2>
          <p className="mt-3 text-sm md:text-base text-accent-200 leading-relaxed">
            来自学生、编辑、上班族与创作者的长期使用反馈，看看他们是怎么用这个站点的。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg border border-accent-800 bg-accent-900/40 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
              <blockquote className="mt-3 flex-1 text-sm text-background-100 leading-relaxed">
                {item.content}
              </blockquote>
              <figcaption className="mt-4 pt-4 border-t border-accent-800 flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-accent-950 font-bold text-sm">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm text-background-50">{item.name}</span>
                  <span className="block text-xs text-accent-300">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}